import { createContext } from "react";

const AtualizationContext = createContext();

export default AtualizationContext;